import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import {Button, Col, FormControl, Row, Table} from 'react-bootstrap';
import {Glyphicon} from "../../Common/GlyphIcon";
import {GuidUtils} from "../../../Utils/GuidUtils";
import {ObjectUtils} from "../../../Utils/ObjectUtils";
import {service as SurveyAnswerService} from "../../../Services/SurveyAnswerService";
import {service as SurveyTypeService} from "../../../Services/SurveyTypeService";
import {SurveyCustomSectionValidatorEnhance} from "../../Common/SurveyForm/SurveyCustomSectionValidatorEnhance";
import {SurveySectionHeader} from "../../Common/SurveyForm/SurveySectionHeader";

@SurveyCustomSectionValidatorEnhance((_survey, _section, customData) => {
    const fields = ['valueImpact', 'valueProposal', 'valueRisk'];

    if(customData?.RiskAssessments?.length > 0) {
        let ret = true;

        customData.RiskAssessments.forEach(x => fields.forEach(y => {
            if(typeof x[y] === 'undefined') { //if field not set
                ret = false;
            } else if(x[y] === '') { //if field is set, but empty
                ret = false;
            }
        }));

        return ret;
    }

    return false;
})
export class RiskAssessments extends Component {
    constructor(props) {
        super(props);

        this.state = {
            surveyTypes: []
        };
    }

    componentDidMount() {
        SurveyTypeService.Get().then((x) => {
            this.setState({ surveyTypes : x.result });
        });
    }

    @autobind
    updateRisk(record, value) {
        const { CustomData, OnCustomDataChange } = this.props;

        let customData = ObjectUtils.Clone(CustomData);
        let x = customData.RiskAssessments.find((x) => this.getSurveyAnswerRiskAssessmentId(x) === this.getSurveyAnswerRiskAssessmentId(record));
        if(x) {
            x.valueRisk = value;
            OnCustomDataChange(customData);
        }
    }

    @autobind
    updateImpact(record, value) {
        const { CustomData, OnCustomDataChange } = this.props;

        let customData = ObjectUtils.Clone(CustomData);
        let x = customData.RiskAssessments.find((x) => this.getSurveyAnswerRiskAssessmentId(x) === this.getSurveyAnswerRiskAssessmentId(record));
        if(x) {
            x.valueImpact = value;
            OnCustomDataChange(customData);
        }
    }

    @autobind
    updateProposal(record, value) {
        const { CustomData, OnCustomDataChange } = this.props;

        let customData = ObjectUtils.Clone(CustomData);
        let x = customData.RiskAssessments.find((x) => this.getSurveyAnswerRiskAssessmentId(x) === this.getSurveyAnswerRiskAssessmentId(record));
        if(x) {
            x.valueProposal = value;
            OnCustomDataChange(customData);
        }
    }

    @autobind
    deleteRow(record) {
        const { CustomData, OnCustomDataChange } = this.props;

        let customData = ObjectUtils.Clone(CustomData);
        customData.RiskAssessments = customData.RiskAssessments.filter((x) => this.getSurveyAnswerRiskAssessmentId(x) !== this.getSurveyAnswerRiskAssessmentId(record));
        OnCustomDataChange(customData);
    }

    @autobind
    addNewRow() {
        const { CustomData, OnCustomDataChange } = this.props;

        let customData = ObjectUtils.Clone(CustomData);
        customData.RiskAssessments.push({
            _tempId: GuidUtils.Generate()
        });
        OnCustomDataChange(customData);
    }

    @autobind
    importRisks() {
        const { CustomData, OnCustomDataChange, ConservationAction } = this.props;
        const { surveyTypes } = this.state || {};

        const elSurveyType = surveyTypes.find((x) => x.code === 'eligibility');

        if(elSurveyType) {
            SurveyAnswerService.GetSurveyAnswers(elSurveyType.surveyTypeId, ConservationAction.conservationActionId)
                .then((x) => {
                    if(x.risks && x.risks.length > 0) {
                        let customData = ObjectUtils.Clone(CustomData);
                        let newRisks = [];

                        x.risks.forEach((y) => {
                            delete y.created;
                            delete y.modified;
                            delete y.deleted;
                            delete y.fromDate;
                            delete y.toDate;
                            delete y.surveyId;
                            delete y.surveyAnswerRiskAssessmentId;

                            y._tempId = GuidUtils.Generate();

                            newRisks.push(y);
                        });

                        customData.RiskAssessments = newRisks;
                        OnCustomDataChange(customData);
                    } else {
                        alert("No risks to import");
                    }
                });
        }
    }

    @autobind
    onSave() {
        const { OnSave } = this.props;

        OnSave?.();
    }

    @autobind
    getSurveyType() {
        const { Survey } = this.props;
        const { surveyTypes } = this.state || {};

        return surveyTypes?.find(x => x.surveyTypeId === Survey?.surveyTypeId);
    }

    @autobind
    getSurveyAnswerRiskAssessmentId(x) {
        return x.surveyAnswerRiskAssessmentId || x._tempId;
    }

    render() {
        const { EditMode, CustomData, Section, id } = this.props;
        const surveyType = this.getSurveyType();
        let displayCopyButton = false;

        if(surveyType?.code !== 'eligibility') {
            if(EditMode && CustomData?.RiskAssessments?.length === 0) {
                displayCopyButton = true;
            }
        }

        return <Col key={Section.surveySectionId} id={id}>
            <SurveySectionHeader section={Section} />
            <Row>
                <Col xs={12}>
                    <Table className="sb-survey-form-table" striped bordered>
                        <tbody>
                            {
                                displayCopyButton ?
                                    <tr>
                                        <td colSpan={2}>
                                            <div className="text-center">
                                                <Button variant="primary" onClick={this.importRisks}>
                                                    <Glyphicon glyph="file">Import Risks from Eligibility Survey</Glyphicon>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>:
                                    null
                            }
                            {   !EditMode && CustomData.RiskAssessments.length === 0 ?
                                <tr>
                                    <td>
                                        <table className="sb-survey-form-child-table">
                                            <tbody>
                                            <tr>
                                                <td className="sb-survey-form-table-custom-risks-value-area">
                                                    No risks defined.
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                : null
                            }
                            {
                                CustomData.RiskAssessments.map((x) =>
                                    <tr key={this.getSurveyAnswerRiskAssessmentId(x)}>
                                        <td className="sb-risk-child-table">
                                            {
                                                EditMode ?
                                                    <div className="sb-survey-form-table-custom-controls float-right">
                                                        <a className="pndlm-remove-control" onClick={() => this.deleteRow(x)}>
                                                            <Glyphicon glyph="remove-sign" />
                                                        </a>
                                                    </div>:
                                                    null
                                            }

                                            <table className="sb-survey-form-child-table">
                                                <tbody>
                                                    <tr>
                                                        <th className="risks-label">
                                                            The risk
                                                        </th>
                                                        <td className="sb-survey-form-table-custom-risks-value-area">
                                                            {
                                                                EditMode ?
                                                                    <FormControl
                                                                        className="sb-survey-form-input-text"
                                                                        as="textarea"
                                                                        value={x.valueRisk == null ? "" : x.valueRisk}
                                                                        onChange={(e) => this.updateRisk(x, e.target.value)}
                                                                    />:
                                                                    <div>{x.valueRisk}</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr className="separator"><th><div/></th><td></td></tr>
                                                    <tr>
                                                        <th className="impact-label">
                                                            Potential impact to the project
                                                        </th>
                                                        <td className="sb-survey-form-table-custom-risks-value-area">
                                                            {
                                                                EditMode ?
                                                                    <FormControl
                                                                        className="sb-survey-form-input-text"
                                                                        as="textarea"
                                                                        value={x.valueImpact == null ? "" : x.valueImpact}
                                                                        onChange={(e) => this.updateImpact(x, e.target.value)}
                                                                    />:
                                                                    <div>{x.valueImpact}</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    <tr className="separator"><th><div /></th><td></td></tr>
                                                    <tr>
                                                        <th className="proposal-label">
                                                            Proposed actions to address risk
                                                        </th>
                                                        <td className="sb-survey-form-table-custom-risks-value-area">
                                                            {
                                                                EditMode ?
                                                                    <FormControl
                                                                        className="sb-survey-form-input-text"
                                                                        as="textarea"
                                                                        value={x.valueProposal == null ? "" : x.valueProposal}
                                                                        onChange={(e) => this.updateProposal(x, e.target.value)}
                                                                    />:
                                                                    <div>{x.valueProposal}</div>
                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                )
                            }
                            {
                                EditMode ?
                                    <tr className="sb-mutable-list-add-section" onClick={this.addNewRow}>
                                        <td colSpan={2}>
                                            <a><Glyphicon glyph="plus-sign">Add Risk</Glyphicon></a>
                                        </td>
                                    </tr>:
                                    null
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    {
                        EditMode ?
                            <Button onClick={this.onSave} variant="primary" className="float-right">
                                Save and Continue
                            </Button>:
                            null
                    }
                </Col>
            </Row>
        </Col>;
    }
}


